module.exports = __webpack_public_path__ + "img/169c617.png";